import React from "react";
import "../component/Landing.css"
import Logo from "../image/Logo.png"
import {Link} from "react-router-dom"


const LandingFooter = () =>{
    return(
        <footer className="landing_footer">
                    <section className="landing_content image">
                        <img src={Logo} alt="company logo" />
                        <h2>GEOINFOTECH <br />
                            <span>ACADEMY</span></h2>
                    </section>
                    <section className="landing_content">
                        <li className="head">General</li>
                        {/* <Link to="/"> <li className="body">Geo-Academy</li></Link> */}
                        <a href="https://geoinfotech.ng/" target="_blank" rel="noreferrer"><li className="body">Geoinfotech</li></a>
                        <a href="https://geoinfotech.ng/geostore-maintenance/" target="_blank" rel="noreferrer"><li className="body">Geostore</li></a>
                        <Link to="/contact"><li className="body">Contact Us</li></Link>
                        {/* <a href="https://geoinfotech.ng/upcoming-project/" target="_blank" rel="noreferrer"><li className="body">GeoGis</li></a> */}
                    </section>
                    <section className="landing_content">
                        <li className="head">Account</li>
                        <Link to="/sign_up"><li className="body">Sign up</li></Link>
                        <Link to="/login"><li className="body">Login</li></Link>
                        {/* <Link to="/Admin_sign_up"><li className="body">Admin sign up</li></Link>
                        <Link to="/Admin_login"><li className="body">Admin login</li></Link> */}
                    </section>
                    <section className="landing_content">
                        <li className="head">Product</li>
                        <a href="https://geoinfotech.ng/geostore-maintenance/" target="_blank" rel="noreferrer"><li className="body">GIS data</li></a>
                        <a href="https://geoinfotech.ng/geostore-maintenance/" target="_blank" rel="noreferrer"><li className="body">Survey Equipment</li></a>
                    </section> 
                </footer>
    )
}

export default LandingFooter